var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpgradeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13451",
    "data-name": "Group 13451",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.756,
    height: 22,
    viewBox: "0 0 24.756 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5080",
    "data-name": "Rectangle 5080",
    width: 24.756,
    height: 22,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13041",
    "data-name": "Group 13041",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45426",
    "data-name": "Path 45426",
    d: "M0,248.564H.048c.142.113.117.275.117.425.005,1.056,0,2.112,0,3.168,0,.645,0,1.29,0,1.935,0,.136.01.279-.117.377H0Z",
    transform: "translate(0 -232.488)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45427",
    "data-name": "Path 45427",
    d: "M284.151,5.52,287.337,0l3.191,5.52h-.916c-.507,0-.556.047-.556.546q0,7.813.005,15.626c0,.236-.045.313-.3.308q-1.427-.026-2.854,0c-.256,0-.3-.076-.3-.31q.01-7.825.005-15.65c0-.477-.043-.52-.528-.52h-.938",
    transform: "translate(-265.773)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45428",
    "data-name": "Path 45428",
    d: "M208.028,152.755c0,1.984-.005,3.967.007,5.95,0,.255-.074.3-.31.3-.975-.013-1.951-.009-2.927,0-.169,0-.218-.047-.218-.216q.006-6.035,0-12.07c0-.183.055-.23.234-.229q1.487.012,2.975,0c.191,0,.244.055.243.245-.006,2.008,0,4.015,0,6.023",
    transform: "translate(-191.348 -137.013)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45429",
    "data-name": "Path 45429",
    d: "M105.933,196.429c0,1.516,0,3.032,0,4.549,0,.206-.059.252-.256.25-.992-.01-1.984-.008-2.976,0-.168,0-.216-.045-.216-.215q.007-4.585,0-9.17c0-.175.056-.212.219-.21q1.5.011,3,0c.18,0,.229.044.228.226-.008,1.524,0,3.049,0,4.573",
    transform: "translate(-95.861 -179.236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45430",
    "data-name": "Path 45430",
    d: "M.748,254.251v-5.9c1.087,0,2.174,0,3.261-.015.2,0,.169.118.169.237q0,1.812,0,3.624c0,.62,0,1.24,0,1.86,0,.123,0,.214-.171.213-1.087-.01-2.174-.011-3.261-.015",
    transform: "translate(-0.7 -232.27)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeIcon);
export default __webpack_public_path__ + "static/media/upgrade-icon.e0e1ad469683e611ffd4b13c0d2474de.svg";
export { ForwardRef as ReactComponent };